import script from "./AddFood.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFood.vue?vue&type=script&setup=true&lang=js"

import "./AddFood.vue?vue&type=style&index=0&id=3e0e7bbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0e7bbf"]])

export default __exports__